import { Module, VuexModule, Mutation } from 'vuex-module-decorators'
import { CartSubscription } from '~/graphql/types'

@Module({
  name: 'quote-list',
  stateFactory: true,
  namespaced: true,
})
export default class QuoteList extends VuexModule {
  loading = true
  items: CartSubscription['cart'] = []

  @Mutation
  setLoading(loading) {
    this.loading = loading
  }

  @Mutation
  setItems(items) {
    this.items = items
  }
}
